import { i18n } from "@/setup/i18n-setup";

export class DashboardDataMonthOrQuarterOptionSelect {
	public useQuarter:boolean = false;
	public title:string = ""

	public constructor(data?:any){
		if (!data) {
			this.title = i18n.t("common.vat.vat").toString();
			return;
		};
		this.title = data.title || "";
		this.useQuarter = data.useQuarter == "true" || false;
	}

	public getJSON(){
		return {
			title: this.title,
			useQuarter: this.useQuarter ? "true" : "false"
		};
	}
}